import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { getAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

const normalizeList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.rows)) {
    return payload.rows;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  if (Array.isArray(payload?.detailRows)) {
    return payload.detailRows;
  }

  return [];
};

const normalizePagedResponse = (payload, fallbackPage = 0, fallbackSize) => {
  const rows = normalizeList(payload);

  if (Array.isArray(payload)) {
    return rows;
  }

  const totalElements = Number(
    payload?.totalElements ?? payload?.totalRecords ?? payload?.totalRows ?? payload?.count
  );
  const totalPages = Number(payload?.totalPages ?? payload?.pages ?? payload?.pageCount);
  const pageNumber = Number(payload?.pageNumber ?? payload?.page ?? payload?.number ?? fallbackPage);
  const pageSize = Number(payload?.pageSize ?? payload?.size ?? fallbackSize ?? rows.length);
  const hasNext = Boolean(payload?.hasNext);

  return {
    content: rows,
    rows,
    pageNumber: Number.isFinite(pageNumber) ? pageNumber : fallbackPage,
    pageSize: Number.isFinite(pageSize) ? pageSize : rows.length,
    totalElements: Number.isFinite(totalElements) ? totalElements : rows.length,
    totalPages: Number.isFinite(totalPages) ? totalPages : rows.length ? 1 : 0,
    hasNext,
    totalRows: Number.isFinite(totalElements) ? totalElements : rows.length,
    page: Number.isFinite(pageNumber) ? pageNumber : fallbackPage,
  };
};

export const getDCCostItemsRows = async (batchId, { page = 0, size } = {}) => {
  const tokenInfo = await getJWTToken();
  if (!tokenInfo) {
    window.location.href = "/";
    return [];
  }

  const normalizedBatchId = batchId ?? "";
  const queryParams = new URLSearchParams();
  if (Number.isFinite(Number(page))) {
    queryParams.set("page", String(page));
  }
  if (Number.isFinite(Number(size))) {
    queryParams.set("size", String(size));
  }

  const queryString = queryParams.toString();
  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.dcCostItems}/${normalizedBatchId}${
    queryString ? `?${queryString}` : ""
  }`;
  const response = await getAPI(apiUrl, tokenInfo);

  if (response.ok) {
    const payload = await response.json().catch(() => []);
    return normalizePagedResponse(payload, page, size);
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to load DC cost detail data.", { contactSupport: false });
  return [];
};

export default getDCCostItemsRows;
